// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_SfyQy","title":"title_d-jGY","g-title":"g-title"};